import React, { useContext, useMemo, Fragment } from 'react';
import { ShowContext } from '../../context/showContext.js';
import { Link } from 'react-router-dom';
import './Home.module.css';
import { dataImages, dimensionsH, dimensionsV } from '../../data/data.js';
import useWindowWidth from '../../helpers/helper.js'

export const Home = () => {

  const { isShow, setIsSHow, imageDescription, setimageDescription } = useContext(ShowContext)

  const isDesktop = useWindowWidth(600);

  const handleHover = (e) => {
    setIsSHow(true);
    setimageDescription(
      {
        'title': e.title,
        'description': e.description,
        'dimensions': e.dimensions
      }
    )
  }

  const handleHoverOut = () => {
    setIsSHow(false);
  }

  const images = useMemo(() => {
    return dataImages.map((image) => {
      let randomDimensionH = dimensionsH[Math.floor(Math.random() * dimensionsH.length)];
      let randomDimensionV = dimensionsV[Math.floor(Math.random() * dimensionsV.length)];
      console.log(image.path)
      return (
        // eslint-disable-next-line react/jsx-key
        <Fragment>
          {
            isDesktop ? (
              <Link to={image.path}>
                <img
                  style={{
                    width: image.orientation == "h" ? Number(randomDimensionH.width) : Number(randomDimensionV.width),
                    height: 'auto',
                    marginRight: 20,
                    marginBottom: 20,
                  }}
                  className='homeImgDesktop'
                  src={image.pictureSrc}
                  resizeMode="contain"
                  key={image.id}
                  onMouseEnter={() => handleHover(image)}
                  onMouseLeave={() => handleHoverOut()}
                  onClick={() => handleHoverOut()}
                />
              </Link>

            ) : (
              <div className='homeImgMobileContainer'>
                <Link to={image.path}>
                  <img
                    style={{
                      maxWidth: "100%",
                    }}
                    className="homeImg"
                    src={image.pictureSrc}
                    resizeMode="contain"
                    key={image.id}
                  />
                </Link>
                <div>
                  <p>{image.description}</p>
                  <p>{image.dimensions}</p>
                </div>
              </div>
            )
          }
        </Fragment>
      )
    }
    )
  }, []);

  return (
    <Fragment>
      {images}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/pages/home/Home.jsx